import { render, staticRenderFns } from "./RoleSelect.vue?vue&type=template&id=7510842d&scoped=true"
import script from "./RoleSelect.vue?vue&type=script&lang=ts"
export * from "./RoleSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7510842d",
  null
  
)

export default component.exports